import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Safely format a date value, returning a fallback for invalid/null dates.
 * @param {string|Date|null|undefined} dateValue - The date to format
 * @param {string} fallback - What to show if date is invalid (default: '-')
 * @param {object} options - Intl.DateTimeFormat options
 * @returns {string} Formatted date or fallback
 */
export function formatDateSafe(dateValue, fallback = '-', options = { year: 'numeric', month: 'short', day: 'numeric' }) {
  if (!dateValue) return fallback;
  
  const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
  
  // Check if date is valid
  if (isNaN(date.getTime())) return fallback;
  
  return date.toLocaleDateString('en-US', options);
}

/**
 * Check if a date value is valid
 * @param {string|Date|null|undefined} dateValue 
 * @returns {boolean}
 */
export function isValidDate(dateValue) {
  if (!dateValue) return false;
  const date = typeof dateValue === 'string' ? new Date(dateValue) : dateValue;
  return !isNaN(date.getTime());
}
